<section class="alternative-subscription" [class.isTrial]="userSubscription?.trialClient" [class.mobile]="isMobile">
<!--  <ng-container *ngIf="userSubscription?.trialClient; else mainPlanView">
    <section class="free-plan-block">
      <ds-plan-info
        class="starter-block block"
        [userSubscription]="userSubscription"
        [visitsInfo]="visitsInfo"
        [hasUpgrade]="hasUpgrade"
        [backupStorageInfo]="backupStorageInfo"
        [hostingStorageInfo]="hostingStorageInfo"
        [websitesInfo]="websitesInfo"
        (onAddWebsite)="addWebsite()"
        (unpause)="unpause.emit($event)"
        [bandwidthInfo]="bandwidthInfo"
        [generatedWebsitesInfo]="generatedWebsitesInfo"
        [user]="user">
      </ds-plan-info>
      <ng-container *ngTemplateOutlet="paymentSection"></ng-container>
    </section>
  </ng-container>-->
    <div class="subscription-plan-blocks" [class.mobile]="isMobile" *ngIf="userSubscription?.trialClient; else PaidClientView">
      <db-current-sub-plan [userSubscription]="userSubscription"
                           [annualPrice]="annualPrice">
      </db-current-sub-plan>
      <db-subscription-plan-details
        [userLocalStorage]="userLocalStorage"
        [paymentMethods]="paymentMethods"
        [activateClicked]="activationClicked"
        [hasUpgrade]="hasUpgrade"
        [currentWorkspaceRole]="currentWorkspaceRole"
        (cancelSub)="cancelSub.emit()"
        (unpause)="unpause.emit($event)"
        (activateUserSubscription)="activateUserSubscription.emit($event)"
        (onRetryUserSubscription)="retryUserSubscription.emit($event)"
        (onAddPaymentMethod)="onAddPaymentMethod.emit($event)"
        [userSubscription]="userSubscription"></db-subscription-plan-details>
    </div>
    <ng-template #PaidClientView>
      <ds-plan-info
        class="starter-block block"
        [userSubscription]="userSubscription"
        [visitsInfo]="visitsInfo"
        [hasUpgrade]="hasUpgrade"
        [backupStorageInfo]="backupStorageInfo"
        [hostingStorageInfo]="hostingStorageInfo"
        [generatedWebsitesInfo]="generatedWebsitesInfo"
        [vibeCodingInfo]="vibeCodingInfo"
        [websitesInfo]="websitesInfo"
        [extraWebsitesInfo]="extraWebsitesInfo"
        [bandwidthInfo]="bandwidthInfo"
        (unpause)="unpause.emit($event)"
        (onUpgradeClick)="showContactSales()"
        [user]="user"
      >
      </ds-plan-info>
      @if (!userSubscription?.is_non_billable) {
          <section>
              <section class="billing-info-block">
                  <!--          <ds-cdn-info class="block"
                                         *ngIf="userSubscription?.plan?.additionalCDNCount ||
                                     userSubscription?.plan?.additionalDomainCount"
                                         [userSubscription]="userSubscription"></ds-cdn-info>-->
                  <ng-content select="ds-billing-info"></ng-content>
              </section>
              <ng-content select=".db-actions-wrap"></ng-content>
          </section>
          <div class="test"></div>
          <ng-container *ngTemplateOutlet="paymentSection"></ng-container>
      }
    </ng-template>
</section>
<db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
<ng-template #paymentSection>
  <ng-content select="ds-payment-button"></ng-content>
</ng-template>
